module.exports = require("@splunk/themes/enterprise");